import { render } from "./fail-modal.vue?vue&type=template&id=63e468a0&scoped=true&ts=true"
import script from "./fail-modal.vue?vue&type=script&lang=ts"
export * from "./fail-modal.vue?vue&type=script&lang=ts"

import "./fail-modal.vue?vue&type=style&index=0&id=63e468a0&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e468a0"]])